// import React, { createContext, useContext, useState, useEffect } from "react";
// import { getRolesApi, getUserRoles } from "../services/roles";
// import { toast } from "react-toastify";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
// const [loading, setLoading] = useState(true);
//   const [currentRole,setCurrentRole] = useState(null)
//   const [userDetails, setUserDetails] = useState(null);
//   // useEffect(() => {
//   //   const token = localStorage.getItem("token");
//   //   const user = localStorage.getItem("user");
//   //   let role = null
//   //   console.log(user,"user")
//   //   if(user!=undefined)
//   //    role = JSON.parse(user)?.role
//   //   setCurrentRole(role)

//   //   setUser(token ? { token } : null);
//   // }, []);
// useEffect(() => {
//   const token = localStorage.getItem("token");
//   const storedUser = localStorage.getItem("user");
//   if (token && storedUser) {
// setToken(token)

//     try {
//       const parsedUser = JSON.parse(storedUser);
//       const role = parsedUser?.role?.name || null;

//       setUser(parsedUser);
//       setCurrentRole(role);
//     } catch (error) {
//       console.error("Failed to parse user from localStorage:", error);
//       setUser(null);
//       setCurrentRole(null);
//     }
//   } else {
//     setUser(null);
//     setCurrentRole(null);
//   }
//    setLoading(false);
// }, []);
//   useEffect(() => {
//     if(!currentRole)
//       getRoles();
//   }, []);

//   const login =async  (token, userDetails) => {
//     localStorage.setItem("token", token);
//     localStorage.setItem("user", JSON.stringify(userDetails));
//     console.log(userDetails,"details user line 23")
//     await storeRolePresent()
//     setToken(token)
//     setUser(userDetails);
//     console.log(userDetails,"on login")
//   };

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("userDetails");
//     localStorage.removeItem("user");
//     setUserDetails(null);
//     setUser(null);
// setToken(null)

//     return true;
//   };
//   const getItemFromStorage = (key) => {
//     let item = localStorage.getItem(key);
//     return JSON.parse(item);
//   };

//   const getRoles = async () => {
//     let stringify = localStorage.getItem("userDetails");
//     let jsonDetails = JSON.parse(stringify);

//     if (!jsonDetails) {
//       let res = await getUserRoles();
//       console.log(res, "response roles ");
//       if (res?.status == 401) {
//         toast.error(res?.message);
//         return;
//       }
//       const details = { ...res?.user, permissions: res.permissions };
//       setUserDetails(details);
//       setUser(details)
//       localStorage.setItem("userDetails", JSON.stringify(details));
//     } else {
//       setUserDetails(jsonDetails);
//     }

//     //  if(res?.)
//   };
// useEffect(()=>{
//   storeRolePresent()
// },[])
//   const storeRolePresent = async()=>{
//     try {
//       let res = await getUserRoles()
//       console.log(res?.user,"current role")
//       if(res?.status==='error') {
//         logout()
//         return 
//       }
//        localStorage.setItem("user", JSON.stringify(res?.user));
//        setCurrentRole(res?.user?.role)
//        return 

//     } catch (error) {
//       console.log(error,"error in getting role")
//       return 
//     }
//   }

//   const checkRolePresent = (role) => {
    
//     const checkRole = userDetails?.permissions?.find((x) => x.slug === role);
//     if (checkRole) return true;
//     return false;
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         login,
//         logout,
//         getItemFromStorage,
//         getRoles,
//         userDetails,
//         checkRolePresent,
//         currentRole,
//         token,
//         loading
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
import React, { createContext, useContext, useState, useEffect } from "react";
import { getRolesApi, getUserRoles } from "../services/roles";
import { toast } from "react-toastify";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentRole, setCurrentRole] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  // Initialize auth state from localStorage
  useEffect(() => {
    const initializeAuth = async () => {
      const storedToken = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (storedToken && storedUser) {
        setToken(storedToken);
        
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
          
          // Get the latest role information
          await storeRolePresent();
        } catch (error) {
          console.error("Failed to parse user from localStorage:", error);
          // Clear invalid data
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setUser(null);
          setCurrentRole(null);
        }
      }
      
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const login = async (token, userDetails) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userDetails));
    
    setToken(token);
    setUser(userDetails);
    
    // Get the detailed role information after login
    await storeRolePresent();
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("user");
    
    setUserDetails(null);
    setUser(null);
    setToken(null);
    setCurrentRole(null);
    
    return true;
  };

  const getItemFromStorage = (key) => {
    try {
      let item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Failed to parse ${key} from localStorage:`, error);
      return null;
    }
  };

  const getRoles = async () => {
    let stringify = localStorage.getItem("userDetails");
    let jsonDetails = stringify ? JSON.parse(stringify) : null;

    if (!jsonDetails) {
      try {
        let res = await getUserRoles();
        console.log(res, "response roles");
        
        if (res?.status === 401 || res?.status === 'error') {
          toast.error(res?.message || "Authentication failed");
          logout();
          return;
        }

        const details = { ...res?.user, permissions: res.permissions };
        setUserDetails(details);
        localStorage.setItem("userDetails", JSON.stringify(details));
      } catch (error) {
        console.error("Error fetching roles:", error);
        toast.error("Failed to fetch user roles");
      }
    } else {
      setUserDetails(jsonDetails);
    }
  };

  const storeRolePresent = async () => {
    try {
      let res = await getUserRoles();
      console.log(res?.user, "current role");
      
      if (res?.status === 'error' || res?.status === 401) {
        logout();
        return;
      }

      if (res?.user) {
        // Update the stored user with the latest role information
        localStorage.setItem("user", JSON.stringify(res.user));
        setCurrentRole(res.user?.role);
        
        // Update the current user state with the latest information
        setUser(prevUser => ({
          ...prevUser,
          ...res.user
        }));
      }
    } catch (error) {
      console.log(error, "error in getting role");
    }
  };

  const checkRolePresent = (role) => {
    const checkRole = userDetails?.permissions?.find((x) => x.slug === role);
    return !!checkRole;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        getItemFromStorage,
        getRoles,
        userDetails,
        checkRolePresent,
        currentRole,
        token,
        loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);